// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Radio_wrapper__UTfj8","radioWrapper":"Radio_radioWrapper__GqfFS","radioInput":"Radio_radioInput__1QV30","radio":"Radio_radio__1Lp8Q","label":"Radio_label__1Ggln"};